import { adminHttpClient } from '../../commons/adminHttpClient'

export interface PerksAchPaymentValues {
  recurlyToken: string
  billingEmail: string
}

const perksAchPaymentApi = (achPaymentValues: PerksAchPaymentValues): Promise<any> => {
  return adminHttpClient.post('/AdminSignup/Perks/Subscription/Payment/Ach', achPaymentValues)
}

export default perksAchPaymentApi
